import { ParentContext } from "global/cnr/contexts/ParentContext";
import { gEnums } from "global/enums/globalEnums";
import _ from "lodash";
import { useCallback, useContext, useState } from "react";
import { SportsSeasonContext } from "../cnr/contexts/SportsSeasonContext";
import { getLevelMatchez } from "../cnr/reducers/reducerHelpers/seasonSportsData";
import { MatchDataUpdateContext } from "../elements/matches/MatchDataUpdate";
import { matchFilterHelpers } from "../elements/matches/MatchFilters";

export const useMatchSchedule = (props, selectedDate) => {

  const msdts = gEnums.matchScheduleDisplayTypes

  const {
    _levelDateGroups,
    directMatches,
    forBackup,
    forPlayoff,
    matchTeams,
    teamKey,
  } = props;

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { paps_state } = states ?? {};

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, seasonMatches_info, teams_info } = sportsSeason_state ?? {};
  const _matches_info = forBackup && seasonMatches_info ? seasonMatches_info : matches_info;
  const { matches_groupInfo, matches_matchDay } = _matches_info ?? {};
  const { levelDateGroups, matches_combined } = matches_groupInfo ?? {};
  const { teams } = teams_info ?? {};

  // matchDataUpdateContext
  const matchDataUpdateContext = useContext(MatchDataUpdateContext);
  const { sportsData_state } = matchDataUpdateContext ?? {};
  const { matchPlayoffPendings } = sportsData_state ?? {};

  const { pathViews } = paps_state ?? {};

  const getLsdms = useCallback(() => {
    return get_LSMD(matches_combined)
  })

  const getScheduleMatches = useCallback(({ matchScheduleDisplayType, matchFilter, tk }) => {
    const mmm = get_scheduleMatches(matchScheduleDisplayType, matchFilter, tk)
    return mmm
  })

  const get_scheduleMatches = (msdt, matchFilter, tk) => {

    const team_key = tk || teamKey || pathViews.teams

    switch (msdt) {
      case msdts.direct:
        return directMatches

      case msdts.currentMatches:
        return _levelDateGroups

      case msdts.levelTabsFull:
        return get_LSMD(matches_combined)

      case msdts.sport_allDates:
      case msdts.clickedDates:
      case msdts.levelDates:
      case msdts.selectedDate:
        return levelDateGroups

      case msdts.scoreboard:
        return matchFilterHelpers.getTodaysLevelMatches(levelDateGroups, 8, selectedDate)

      case msdts.teamSchedule:
      case msdts.teamScheduleMini:
        if (!_.isEmpty(matchFilter)) {
          const tsf = matchFilterHelpers.getFilterMatches(matches_combined, team_key, matchFilter)
          return tsf
        }
        return matchFilterHelpers.getMatchesForTeam(matches_combined, team_key)

      case msdts.levelOverviewMatches:
        return matchFilterHelpers.getLatestMatches(matches_combined, team_key, 4)

      case msdts.nextTeamMatch:
        const nm = matchFilterHelpers.getNextMatch(matches_combined, team_key)
        return nm ? [nm] : []

      case msdts.teamScheduleRemaining:
        return matchFilterHelpers.getMatchesForTeam(matches_combined, team_key, forPlayoff ? false : true)

      case msdts.missing:
        return matchFilterHelpers.getMissingMatches(matches_combined)

      case msdts.matchDay:
        return matches_matchDay && matchFilterHelpers.getMatchDayMatches(matches_combined, matches_matchDay)

      case msdts.pendingMatches:
        if (matchPlayoffPendings) {
          const { _levelDateGroups } = getLevelMatchez(matchPlayoffPendings);
          return _levelDateGroups
        }
        const x = _matches_info && matchFilterHelpers.getPendingMatches(_matches_info, true)
        return x

      case msdts.teamsCommon:
        const tdms = _matches_info && matchTeams && matchFilterHelpers.getTeamDirectMatches(matches_combined, matchTeams)
        return tdms
    }
  }

  return { getLsdms, getScheduleMatches }

};

const dateToTimestamp = (dateStr) => {
  const [month, day, year] = dateStr.split('/').map(Number);
  return new Date(year, month - 1, day).getTime();
};


const get_LSMD = (matches) => {

  // Step 1: group by _matchCollectionKey (or 'levels')
  const groupedByLevel = _.groupBy(matches, '_matchCollectionKey');

  // Step 2: for each level, group by startDate and sort chronologically
  const matches_byLevel = _.mapValues(groupedByLevel, (levelGroup) => {

    // group by startDate
    const groupedByDate = _.groupBy(levelGroup, 'startDate');

    // sort the dates
    const sortedByDate = {};
    // const sectionMatches = {}

    _.keys(groupedByDate) // using _.keys here
      .sort((a, b) => dateToTimestamp(a) - dateToTimestamp(b))
      .forEach((date) => {
        // group by sections within each date
        const _sectionMatches = _.groupBy(groupedByDate[date], 'sections');
        sortedByDate[date] = _sectionMatches
        // sectionMatches[date] = {}
        // _.forEach(_sectionMatches, (matches, sectionKey) => {
        //   sectionMatches[date][sectionKey] = _.map(matches, '_itemKey')
        // })

      });


    return sortedByDate;
  });


  const matches_added = []

  _.forEach(matches_byLevel, (matches_level, levelKey) => {
    switch (levelKey) {
      case 'Non':
      case 'nonDistrict':
        _.forEach(matches_level, (groupedMatches, groupDateKey) => {
          _.forEach(groupedMatches, (dateMatches, dataMatchKey) => {
            _.forEach(dateMatches, (match) => {
              const { home, away, _itemKey: matchKey } = match;
              const level_home = home?.levels;
              const level_away = away?.levels;

              if (level_home && !_.includes(matches_added, matchKey)) {
                _.update(
                  matches_byLevel,
                  [level_home, groupDateKey, dataMatchKey],
                  (arr = []) => {
                    arr.push(match);
                    return arr;
                  }
                );
                matches_added.push(matchKey)
              }

              if (level_away && !_.includes(matches_added, matchKey)) {
                _.update(
                  matches_byLevel,
                  [level_away, groupDateKey, dataMatchKey],
                  (arr = []) => {
                    arr.push(match);
                    return arr;
                  }
                );
                matches_added.push(matchKey)
              }
            });
          });
        });
    }
  });

  return { levelSectionDateMatches: matches_byLevel, scheduleLevelKeys: _.keys(matches_byLevel) }

}